import Engine, {
  type PlaybackTelemetry,
  type StreamSurfaceProps,
} from "../../../player/StreamSurface";
import {
  playbackCompleted,
  playbackFailed,
  playbackPlaying,
  playbackRebuffered,
  playbackStarted,
} from "../../lib/playbackTelemetry";

export type {
  StreamLicence,
  StreamSurfaceProps,
} from "../../../player/StreamSurface";

/**
 * The TV's video surface: the shared playback engine (`src/player/`) with the
 * TV's own telemetry plugged in.
 *
 * The engine moved to `src/player/` so the web streaming app
 * (`docs/design/web-streaming-app.md`) plays through the SAME code: one Shaka
 * lifecycle, one licence-renewal filter, one failure vocabulary. The only TV
 * thing it ever imported was the PLAYER-17 counters, which are now handed in
 * here, so nothing the TV does changed.
 */
const TV_TELEMETRY: PlaybackTelemetry = {
  started: playbackStarted,
  playing: playbackPlaying,
  failed: playbackFailed,
  rebuffered: playbackRebuffered,
  completed: playbackCompleted,
};

export default function StreamSurface(
  props: Omit<StreamSurfaceProps, "telemetry">
) {
  return <Engine {...props} telemetry={TV_TELEMETRY} />;
}
